import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-allergens',
  templateUrl: './allergens.component.html',
  styleUrls: ['./allergens.component.scss'],
})
export class AllergensComponent {
  @Input() attributes: any[];
  @Input() isAdminOrderCaptureUpdate: boolean;

  isAllergenSelected(name: string) {
    const attr = this.attributes?.find((item) => item.key === name);
    return attr ? attr.value : false;
  }
}
